import { Hourglass } from 'lucide-react';
import { Button } from '@/design-system/components/Button/Button';
import { buttonVariants } from '@/design-system/components/Button/buttonVariants';
import { cn } from '@/lib/utils';

/**
 * Shown to someone who has signed in to DemoOps but has been given no access
 * yet (access matrix, Michael 2026-10-15: "No access until assigned"). New
 * accounts from AD sync start empty; an Admin puts them in a group, and the
 * Admins see who is waiting on Today. Rendered in place of the app — never a
 * redirect, so it cannot loop through the portal's sign-in.
 */
export function AccessPendingScreen({ name }: { name?: string | null }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-graphite-950 p-5">
      <div className="max-w-md text-center">
        <Hourglass className="mx-auto mb-4 h-12 w-12 text-safety-500" aria-hidden="true" />
        <h1 className="mb-3 text-2xl font-semibold text-graphite-100">Waiting for your access</h1>
        <p className="mb-2 leading-relaxed text-graphite-300">
          {name ? `You're signed in, ${name}, ` : "You're signed in, "}but nobody has given you access to
          DemoOps yet.
        </p>
        <p className="mb-6 leading-relaxed text-graphite-500">
          The DemoOps administrators can see that you&rsquo;re waiting. Once they set you up, reload
          this page.
        </p>
        <div className="flex justify-center gap-3">
          <a href="https://nadc1.net/" className={cn(buttonVariants({ variant: 'primary' }))}>
            Back to Portal
          </a>
          <Button variant="outline" onClick={() => window.location.reload()}>
            Try again
          </Button>
        </div>
      </div>
    </div>
  );
}
